import {InputLabel, MenuItem, Select} from "@mui/material";
import Stack from "@mui/material/Stack";
import {useEffect, useState} from "react";
import FormControl from "@mui/material/FormControl";
import useCallDataApi from "../../hooks/data";
import useDataModel from "../../hooks/dataModel";
import {deliveryTypes} from "../../utils/enums";


export default function ConnectionData({reference, order}) {
    const [deliveryCourier, setDeliveryCourier] = useState(order?.delivery_courier_new || null)
    const [returnCourier, setReturnCourier] = useState(order?.return_courier_new || null)

    const {fetchModel: getCouriers, models: couriers, setModels: setCouriers} = useDataModel(useCallDataApi("users"))

    useEffect(() => getCouriers('get_couriers', models => setCouriers(models)), [])


    return <form ref={reference}>
        <Stack>
            {order?.delivery_type === deliveryTypes.HAND && <FormControl sx={{m: 1, minWidth: 120}}>
                <InputLabel id="courier-select">Kiszállító futár</InputLabel>
                <Select
                    labelId="courier-select"
                    label="Kiszállító utár"
                    id="delivery_courier_new"
                    name="nullable-delivery_courier_new"
                    value={deliveryCourier}
                    onChange={e => setDeliveryCourier(e.target.value)}
                >
                    <MenuItem value=''>-</MenuItem>
                    {couriers.map(courier => (
                        <MenuItem key={courier.id} value={courier.id}>{courier.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>}
            {order?.return_type === deliveryTypes.HAND && <FormControl sx={{m: 1, minWidth: 120}}>
                <InputLabel id="courier-select2">Visszaszállító futár</InputLabel>
                <Select
                    labelId="courier-select2"
                    label="Visszaszállító futár"
                    id="return_courier_new"
                    name="nullable-return_courier_new"
                    value={returnCourier}
                    onChange={e => setReturnCourier(e.target.value)}
                >
                    <MenuItem value=''>-</MenuItem>
                    {couriers.map(courier => (
                        <MenuItem key={courier.id} value={courier.id}>{courier.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>}
        </Stack>
    </form>;
}